import axios from "axios";
import { Formik, Form, Field, ErrorMessage } from "formik";
import React, { Component } from 'react'
import apiUrl from "../apiUrlConstant";
import { Redirect, withRouter, Link } from "react-router-dom";
import { getUserCategory, generateRandomFilename } from "../utils/index";
import { Alert } from "react-bootstrap";


const headers = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + localStorage.getItem("TOKEN"),
};



class MyProfile extends React.Component {
    state = {
        userDetails: JSON.parse(localStorage.getItem("user")),
        profilePhoto: "",
        imageData: "",
        showAlert: false,
        initialValues: {
            fullName: '',
            phone: '',
            email: '',
            city: '',
            state: '',
            country: '',
            pincode: '',
            role: '',
            creationDate: ''
        },
        fileError:''
    };

    componentDidMount = () => {

        
        var ths = this;
        fetch(`${apiUrl.apiUrl.url}/client/fetch-user-details`, { headers })
            .then((response) => {
                return response.json();
            })
            .then((data) => {
                let country = data.form_data.countryId['countryName'] || '';
                let state = data.form_data.stateId.map(item => item.label).join(', ');
                let city = data.form_data.cityId.map(item => item.label).join(', ');
                let name = data.data.name;
                let initialValues = {
                    fullName: data.data.name,
                    phone: data.data.mobile,
                    email: data.data.email,
                    city: city,
                    state: state,
                    country: country,
                    role: data.data.roleName,
                    creationDate: data.data.creationDate
                };

                let profileImageUrl = data.data.profilePic && data.data.profilePic !== '' ? apiUrl.apiUrl.url + '/' + data.data.profilePic : '';
                ths.setState({
                    initialValues: initialValues,
                    profilePhoto: profileImageUrl
                });
            })
            .catch((error) => {
                console.log(error);
            });
    }


    fileBrowseHandler = (event) => {
        const allowedExtensions = ["png", "jpeg", "jpg", "gif"];
        let extension = event.target.files[0].name.split('.').pop().toLowerCase();

        if (!allowedExtensions.includes(extension)) {
            this.setState({ fileError: "Invalid file type! Allowed: GIF, PNG, JPEG" });
            event.target.value = ""; 
            return;
        } else {
            this.setState({ fileError: "" }); // Clear error if valid
        }


        let value = URL.createObjectURL(event.target.files[0]);
        this.setState({
            profilePhoto: value,
            imageData: event.target.files[0]
        }, () => {
            //console.log(this.state.profilePhoto)
        });
    };

    uploadProfilePicture = (e) => {
        this.setState({ showAlert: false });
        if (this.state.imageData) {
            let folderUploadName = getUserCategory() != '' ? getUserCategory() : 'admin';
            const formData = new FormData();
            formData.append(
                'imageFile', this.state.imageData
            );

            let filename = generateRandomFilename(this.state.imageData.name);
            formData.append(
                'file_name', 'profile_' + filename,
            );
            formData.append(
                'folder_location', folderUploadName + '/profile_picture',
            );

            try {
                let self = this;
                axios({
                    method: "post",
                    url: `${apiUrl.apiUrl.url}/upload-document/save`,
                    data: formData,
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }).then(function (response) {
                    //console.log(response);
                    let profileData = {
                        profile_url: response.data.filePath
                    };
                    axios({
                        method: "post",
                        url: `${apiUrl.apiUrl.url}/user/upload-profile`,
                        data: profileData,
                    }).then(function (response) {
                        if (response.data.status == 'success') {
                            self.setState({ showAlert: true });

                            let userDetails = JSON.parse(localStorage.getItem("user"));
                            userDetails.profile_pic = "upload/"+folderUploadName.toLowerCase() + '/profile_picture/profile_'+filename; 
                            localStorage.setItem("user", JSON.stringify(userDetails));
                            console.log(userDetails);

                            setTimeout(() => {
                                window.location.reload();
                            }, 2000);
                            
                        }
                    }).catch(function (error) {
                        console.error('Error uploading file:', error);
                    });

                }).catch(function (error) {
                    console.error('Error uploading file:', error);
                });

            } catch (error) {
                console.error('Error uploading file:', error);
            }
        } else {
            alert("Please select a photo to upload.");
        }
    }

    deleteProfilePicture = (e) => {
        this.setState({ showAlert: false });
        try {
            let profileData = {
                profile_url: ''
            };
            var self = this;
            axios({
                method: "post",
                url: `${apiUrl.apiUrl.url}/user/upload-profile`,
                data: profileData,
            }).then(function (response) {
                if (response.data.status == 'success') {
                    self.setState({ showAlert: true });

                    let userDetails = JSON.parse(localStorage.getItem("user"));
                    userDetails.profile_pic = ""; 
                    localStorage.setItem("user", JSON.stringify(userDetails));

                    setTimeout(() => {
                        window.location.reload();
                    }, 2000);
                }
                self.setState({
                    profilePhoto: '',
                    imageData: null
                });
            }).catch(function (error) {
                console.error('Error uploading file:', error);
            });

        } catch (error) {
            console.error('Error uploading file:', error);
        }
    }


    render() {
        return (
            <>
                <div className="absoluteItemForTopBar">
                    <div className="new_breadcrumbs_design">
                        <h5>Profile Details</h5>
                    </div>
                </div>
                <div className='masterContainer mt-4'>
                    <div className="row m-0 myProfileMain">
                        <div className="col-sm-3 ps-0 myProfileMainL">
                            <div className="profilePhotoUpdate">
                                <label htmlFor="uploadButtonImage" className="profilePhotoMain position-relative">
                                    <input type="file" accept=".png, .gif, .jpeg, .jpg" onChange={this.fileBrowseHandler} name="uploadButton" id="uploadButtonImage" />
                                    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
                                        <path fill="currentColor" d="M11 13h2.73zm-9 7V6h4.573l1.85-2h5.193v1h-4.76L7.012 7H3v12h16v-8.615h1V20zM19 7V5h-2V4h2V2h1v2h2v1h-2v2zm-8 9.73q1.567 0 2.649-1.081T14.731 13t-1.082-2.649T11 9.269t-2.649 1.082T7.269 13t1.082 2.649T11 16.731m0-1q-1.165 0-1.948-.783T8.269 13t.783-1.948T11 10.269t1.948.783t.783 1.948t-.783 1.948t-1.948.783" />
                                    </svg>
                                    {this.state.profilePhoto ? <img src={this.state.profilePhoto} className="img-fluid profilePhotoMain" /> : this.state.userDetails.name.match(/\b(\w)/g).join('')}
                                </label>

                                {this.state.fileError && (
                                    <label className="text-danger mt-1 position-relative">{this.state.fileError}</label>
                                )}

                                <div className="profilePhotoButton mt-4 mb-5">
                                    <button onClick={this.uploadProfilePicture}>Upload Image</button>
                                    {this.state.profilePhoto ? (
                                        <button className="deleteImage" onClick={this.deleteProfilePicture}>Delete Image</button>
                                    ) : null}
                                </div>
                                
                                {this.state.initialValues.creationDate!='' ? (
                                <div className="profilePhotoText text-center">
                                    <span>Account since</span>
                                    <p>{this.state.initialValues.creationDate}</p>
                                </div>
                                ) : null}
                            </div>
                        </div>
                        <div className="col-sm-9 pe-0 myProfileMainR">
                            {this.state.showAlert == true ? (
                                <Alert variant="success">
                                    <ul className="m-0">
                                        Profile picture updated successfully
                                    </ul>
                                    <span onClick={() => this.setState({ showAlert: false })}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
                                            <path fill="currentColor" d="M10.586 12L2.793 4.207l1.414-1.414L12 10.586l7.793-7.793l1.414 1.414L13.414 12l7.793 7.793l-1.414 1.414L12 13.414l-7.793 7.793l-1.414-1.414z" />
                                        </svg>
                                    </span>
                                </Alert>
                            ) : null}
                            <Formik
                                innerRef={this.formikRef}
                                initialValues={this.state.userDetails}
                                enableReinitialize
                                onSubmit={(values, actions) => {
                                    //console.log(values)
                                }}
                            >
                                <div className="unitFormContainerNew">
                                    <Form autoComplete="off">
                                        <div className="newGridSectionParent">
                                            <div className="newGridSectionForFormMain">
                                                <div className="newGridSectionInner">
                                                    <label htmlFor="firstname">Full Name</label>
                                                    <div className="position-relative">
                                                        <Field type="text" name="fullName" value={this.state.initialValues.fullName} readOnly={true} />

                                                    </div>
                                                </div>
                                                <div className="newGridSectionInner">
                                                    <label htmlFor="phone">Phone Number</label>
                                                    <div className="position-relative">
                                                        <Field type="tel" name="phone" value={this.state.initialValues.phone} readOnly={true} />
                                                    </div>
                                                </div>
                                                <div className="newGridSectionInner">
                                                    <label htmlFor="email">E-mail ID</label>
                                                    <div className="position-relative">
                                                        <Field type="email" name="email" value={this.state.initialValues.email} readOnly={true} />
                                                    </div>
                                                </div>
                                                <div className="newGridSectionInner">
                                                    <label htmlFor="city">City</label>
                                                    <div className="position-relative">
                                                        <Field type="text" name="city" value={this.state.initialValues.city} readOnly={true} />
                                                    </div>
                                                </div>
                                                <div className="newGridSectionInner">
                                                    <label htmlFor="state">State</label>
                                                    <div className="position-relative">
                                                        <Field type="text" name="state" value={this.state.initialValues.state} readOnly={true} />
                                                    </div>
                                                </div>
                                                <div className="newGridSectionInner">
                                                    <label htmlFor="country">Country</label>
                                                    <div className="position-relative">
                                                        <Field type="text" name="country" value={this.state.initialValues.country} readOnly={true} />
                                                    </div>
                                                </div>
                                                <div className="newGridSectionInner">
                                                    <label htmlFor="pincode">Role</label>
                                                    <div className="position-relative">
                                                        <Field type="text" name="country" value={this.state.initialValues.role} readOnly={true} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Form>
                                </div>
                            </Formik>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}
export default withRouter(MyProfile);